import { Theme } from '@mui/material'

const classes = {
  deviceInfoItem: (theme: Theme) => ({
    paddingY: 1.5,
    gap: 2,
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: `1px solid ${theme.palette.ui.surfaceContainerHighest}`,
  }),
  deviceInfoLabel: (theme: Theme) => ({
    fontWeight: 400,
    color: theme.palette.text.secondary,
    flexShrink: 0,
  }),
  deviceInfoValue: (theme: Theme) => ({
    color: theme.palette.text.primary,
    textAlign: 'right',
    minWidth: 0,
    overflowWrap: 'anywhere',
    fontWeight: 500,
  }),
  deviceInfoItemContainer: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
  },
}

export default classes
